import { handleActions } from 'redux-actions';

import commonHandlers from './common';
import mavlinkHandlers from './mavlink';

export const initialState = {
  id: null,
  name: '',
  json: {
    specs: {
      protocol: null,
      firmware: null,
      frame: null,
    },
    commands: [],
    fences: [],
  },
  collisions: [],
  elevations: [],
};

export default handleActions(
  {
    ...commonHandlers,
    ...mavlinkHandlers,
  },
  initialState,
);
